var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.69951,
    cy: 16.1561,
    r: 8.69951,
    fill: "#F58220"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69951 0L16.2335 11.1851H1.16551L8.69951 0Z",
    fill: "#F58220"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIa);
export default __webpack_public_path__ + "static/media/ia.543d123c68c75854ab525158832bcd15.svg";
export { ForwardRef as ReactComponent };